import angular from 'angular';

import InventoryLiabilityTabComponent from './inventory-liability-tab-component';

export default angular.module('inventory-liability-tab', []).component('inventoryLiabilityTab', new InventoryLiabilityTabComponent());



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/inventory-liability-tab/inventory-liability-tab-module.js